import PropTypes from 'prop-types';
import cx from 'classnames';

import sty from './TypeChip.module.scss';

const TYPE_CONFIG = {
  nom: { label: 'Nominate Loyalty', icon: '/images/stamp.svg', className: sty.nom },
  win: { label: 'Win Loyalty', icon: '/images/card.svg', className: sty.win },
  dc: { label: 'Dynamic Coupon', icon: '/images/coupon.svg', className: sty.dc },
  mv: { label: 'Merchant View', icon: '/images/mv_icon.svg', className: sty.mv },
};

function TypeChip({ type, label, className }) {
  const key = String(type || '').toLowerCase();
  const config = TYPE_CONFIG[key] || TYPE_CONFIG.nom;

  return (
    <span className={cx(sty.chip, config.className, className)}>
      <span
        className={sty.icon}
        style={{
          WebkitMaskImage: `url(${config.icon})`,
          maskImage: `url(${config.icon})`,
        }}
        aria-hidden="true"
      />
      {label || config.label}
    </span>
  );
}

TypeChip.propTypes = {
  type: PropTypes.oneOf(['nom', 'win', 'dc', 'mv', 'NOM', 'WIN', 'DC', 'MV']),
  label: PropTypes.string,
  className: PropTypes.string,
};

export default TypeChip;
